import styled from 'styled-components'

export const MarketBot = styled.div`
display:flex;
flex-direction:column;
gap:10px;
  
`
export const BotHeader = styled.div`
  border-radius: 10px;
  padding: 10px;
  background-color: #fff;
  display:flex;
  flex-wrap: wrap;
  input{
    flex:1;
    // margin
  }
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  .rpc {
    width: 100%;
    align-items:center;

  }
  .swap {
    flex: 1
  }
`

